<p>{{(value() === true) ? 'Ja' : 'Nee'}}</p>